import { Component, OnInit } from '@angular/core';
import { HeaderVisibilityService } from './services/header-visibility.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { getUser } from './store/selectors/account.selector';
import { OfflineStorageService } from './services/offline-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'new-alamat-web-v1';
  showHeader: boolean = true;

  currentRoute: string = '';

  getUserProfile$: Observable<any>;
  user: any;

  ngUnsubscribe = new Subject<void>();

  userProfile: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>,
    private offlineStorageService: OfflineStorageService
  ) {
    this.getUserProfile$ = this.store.select(getUser);
   }

  ngOnInit() {
    this.initializeApp();
  }

  async initializeApp(){
    // this.getUserProfile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
    //   this.user = res;
    //   this.router.navigate(['/home/dashboard'])
    // })
    const user = await this.offlineStorageService.getObject('user'); 
    if(user){
      this.userProfile = JSON.parse(user);
      this.router.navigate(['/home/dashboard'])
    }
    // this.activatedRoute.url.subscribe(urlSegments => {
    //   this.currentRoute = urlSegments.map(segment => segment.path).join('/');
    //   console.log(this.currentRoute)
    // });

    // this.router.events.subscribe(async event => {
    //   if (event instanceof NavigationEnd) {
    //     this.currentRoute = event.urlAfterRedirects; // Get updated URL after navigation
    //     this.router.navigate(['/home/dashboard'])
    //     // if(!this.user){
    //     //   this.router.navigate(['/home/dashboard'])
    //     // }
    //   }
    // });
  }

  removeLastSegment(url: string): string {
    const segments = url.split('/');
    segments.pop(); // Remove last segment
    return segments.join('/'); // Reconstruct the URL
  }
}
